<template>

    <v-btn
        class="square create"
        :class="customClass"
        @click="callback"
    >
        <v-icon size="50px">add</v-icon>
    </v-btn>
</template>

<script>

export default {

    components: {

    },

    props: {
        callback: {
            type: Function,
            required: true,
        },
        customClass: {
            type: String,
            required: false,
            default: '',
        },
    },

    data (){
        return {

        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Partials/create-new-button.vue